import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import DebitProductDetailsFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/prepaid/debitProductDetails/DebitProductDetailsFormHandle';
import CardsListByDebitProductFormHandle from '@Modules/reporting/containers/forms/cardManagementSystem/prepaid/cardsListByDebitProduct/CardsListByDebitProductFormHandle';

const Debit = () => {
  return (
    <div>
    <CC.Tabs>
      <div style={{overflowX: "auto"}}>
      <CC.TabList>
        <CC.Tab minWidth={'fit-content'}>Détails Produit Débit</CC.Tab>
        <CC.Tab minWidth={'fit-content'}>Liste des Cartes par Produit Débit</CC.Tab>
      </CC.TabList>
      </div>

      <CC.TabPanels>
        <CC.TabPanel>
          <DebitProductDetailsFormHandle />
        </CC.TabPanel>
        <CC.TabPanel>
          <CardsListByDebitProductFormHandle />
        </CC.TabPanel>
      </CC.TabPanels>
    </CC.Tabs>

    </div>
  )
}

export default Debit;